import get from 'lodash/get';
import {
  SET_APD_CAROUSEL_DATA,
  UPDATE_APD_CAROUSEL_DATA,
} from 'legacy/src/constants/types';

const initialState = {};

const apdCarouselData = (
  state = initialState,
  { type, payload, subject, videoId },
) => {
  switch (type) {
    case SET_APD_CAROUSEL_DATA:
      return {
        ...state,
        [subject]: payload,
      };
    case UPDATE_APD_CAROUSEL_DATA:
      return {
        ...state,
        [subject]: {
          ...get(state, [subject], {}),
          [videoId]: {
            ...get(state, [subject, videoId], {}),
            providerVideoId: videoId,
            playTimePercentage: payload,
          },
        },
      };
    default:
      return state;
  }
};

export default apdCarouselData;
